<template>
  <div class="navbar bg-white breadcrumb-bar">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb" v-if="routeName == 'project'">
        <li class="breadcrumb-item active">
          <router-link :to="{ name: 'all_projects' }" class="text-muted">
            {{$t('projects.parent')}}
          </router-link>
        </li>
        <li class="breadcrumb-item active">
          <router-link :to="{ name: 'category', params: { id: currentProject.project_area_id } }" class="text-muted">
            {{currentProject.project_area_name}}
          </router-link>
        </li>
        <li class="breadcrumb-item active">
          <router-link :to="{ name: 'project', params: { id: currentProject.id } }" class="text-muted">
            {{currentProject.name}}
          </router-link>
        </li>
      </ol> 
      <ol class="breadcrumb" v-if="routeName == 'category'">
        <li class="breadcrumb-item active">
          <router-link :to="{ name: 'all_projects' }" class="text-muted">
            {{$t('projects.parent')}}
          </router-link>
        </li>
        <li class="breadcrumb-item active">
          <router-link :to="{ name: 'category', params: { id: currentProject.project_area_id } }" class="text-muted">
            {{currentProject.project_area_name}}
          </router-link>
        </li>
      </ol>         
      <ol class="breadcrumb" v-else-if="routeName == 'tags'">
        <li class="breadcrumb-item active">
          <router-link :to="{ name: 'all_tags' }" class="d-inline text-muted">
            {{ $t('tags.plural') }}
          </router-link>
        </li>
        <li class="breadcrumb-item active capitalize">{{currentTagName}}</li>
      </ol>
      <ol class="breadcrumb" v-else-if="routeName == 'contact'">
        <li class="breadcrumb-item active">
          <router-link :to="{ name: 'all_contacts' }" class="d-inline text-muted">
            {{ $t('contacts.plural') }}
          </router-link>
        </li>
        <li class="breadcrumb-item active capitalize" v-if="currentContactName">{{currentContactName.name}}</li>
      </ol>
      <ol class="breadcrumb" v-else-if="routeName == null">
        <li class="breadcrumb-item active">Dashboard</li>
      </ol>
      <ol class="breadcrumb" v-else>
        <li class="breadcrumb-item active">{{routeLabel}}</li>
      </ol>
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">{{new Date().toISOString() | formatDateLong}}</li>
      </ol>
    </nav>

    <div class="dropdown">
      <router-link :to="{ name: 'search' }" class="d-inline text-muted">
        <i class="material-icons">search</i>
      </router-link>
      <span data-toggle="dropdown" aria-expanded="false">
        <i class="material-icons pointer">sentiment_very_satisfied</i>
      </span>
      <div class="dropdown-menu dropdown-menu-right">
        <a href="/profile" class="dropdown-item">Profile</a>
        <a rel="nofollow" data-method="delete" href="/users/sign_out" class="dropdown-item">Log Out</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    routeName(){
      return this.$route.name
    },
    routeLabel(){
      var route_name = this.$route.name
      if(route_name == 'today'){
        return 'Today'
      } else if(route_name == 'all'){
        return 'All Items'
      } else if(route_name == 'someday'){
        return this.$t('tier1.someday.name')
      } else if(route_name == 'waiting'){
        return this.$t('tier1.waiting.name')
      } else if(route_name == 'essentials'){
        return this.$t('tier1.essentials.name')
      } else if(route_name == 'in_process'){
        return this.$t('tier1.in_process.name')                        
      } else if(route_name == 'gmail'){
        return 'Gmail Inbox'
      } else if(route_name == 'inbox'){
        return 'Inbox'
      } else if(route_name == 'default'){
        return 'Add a Todo'
      } else if(route_name == 'calendar'){
        return 'Calendar'
      } else if(route_name == 'journal'){
        return 'Journal'
      } else if(route_name == 'project_journal'){
        return this.$t('projects.parent') + ' Journal'
      } else if(route_name == 'contact_journal'){
        return this.$t('contacts.singular') + ' Journal'
      } else if(route_name == 'tag_journal'){
        return this.$t('tags.singular') + ' Journal'
      } else if(route_name ==  'completed_tasks'){
        return 'Completed Tasks'
      } else if(route_name ==  'completed_tasks_by_project'){
        return 'Completed Tasks by Project'
      } else if(route_name ==  'contact_completed_taskst'){
        return 'Completed Tasks by Contact'
      } else if(route_name ==  'tag_completed_taskst'){
        return 'Completed Tasks by Tag'
      } else if(route_name == 'all_tags'){
        return this.$t('tags.plural')  
      } else if(route_name == 'archived_tags'){
        return this.$t('tags.singular') + ' Archive'
      } else if(route_name == 'all_contacts'){
        return this.$t('contacts.plural') 
      } else if(route_name == 'archived_contacts'){
        return 'Archived ' + this.$t('contacts.plural') 
      } else if(route_name == 'trash'){
        return 'Trash'
      } else if(route_name == 'categories'){
        return 'Categories'
      } else if(route_name == 'all_projects'){
        return this.$t('projects.parent')
      } else if(route_name == 'archived_projects'){
        return this.$t('projects.parent') + ' Archive'           
      }
    },
    currentProject(){
      return store.getters.currentProject
    },
    currentTagName(){
      return store.getters.currentTagName
    },
    currentContactName(){
      var param_id = this.$route.params.contact_id
      return this.$store.state.active_contacts.filter(function (contact){
        return (param_id == contact.id)
      })[0]
      // var param = this.$route.params.contact_id
      // if(store.state.user_contacts){
      //   return store.state.user_contacts.find(data => data.id == param).name
      // }
    }
  }
}
</script>
